import { PDFDownloadLink } from '@react-pdf/renderer';
import { useMemo } from 'react';
import OrderPdfGenerator from '../../OrderPage/MainOrderInfo/OrderPdfGenerator/OrderPdfGenerator';

function OrderPdfDownloadButton({
    order,
    items,
    className,
    ariaLabel,
    renderContent,
}) {
    const pdfDocument = useMemo(() => {
        if (!order || !items || items.length === 0) return null;
        return <OrderPdfGenerator data={order} orderItmes={items} />;
    }, [items, order]);

    const pdfFileName = useMemo(() => (
        order?.ai_id ? `order-${order.ai_id}.pdf` : 'order.pdf'
    ), [order?.ai_id]);

    if (!pdfDocument) return null;

    return (
        <PDFDownloadLink
            document={pdfDocument}
            fileName={pdfFileName}
            className={className}
            aria-label={ariaLabel}
        >
            {({ loading }) => (
                renderContent
                    ? renderContent({ loading })
                    : loading ? 'Создаем PDF...' : 'Выгрузить заказ в PDF'
            )}
        </PDFDownloadLink>
    );
}

export default OrderPdfDownloadButton;
